import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Capacitor, CapacitorHttp } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private httpClient: HttpClient) { }

  public upload(url: string, paramsData?: {}, token?: string): Observable<HttpEvent<any>> {
    // CapacitorHttp (activo en Android/iOS, ver capacitor.config.ts) intercepta el HttpClient de
    // Angular parcheando fetch/XMLHttpRequest, y según la propia documentación de Capacitor,
    // "parsear y transferir grandes cantidades de datos... puede causar problemas" con tipos
    // complejos (como el base64 grande de un PDF embebido en un JSON) a través de esa interceptación
    // automática — en Android concretamente el backend responde "Wrong content-type" (409). La propia
    // documentación recomienda usar la API nativa CapacitorHttp.post() directamente para estos casos,
    // así que en nativo evitamos el HttpClient interceptado y llamamos a CapacitorHttp.post() a mano.
    if (Capacitor.isNativePlatform()) {
      return this.uploadNative(url, paramsData, token);
    }

    let headersOptions: {} = null;

    if (token) {
      headersOptions = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token };
    } else {
      headersOptions = { 'Content-Type': 'application/json' };
    }
    const headers = new HttpHeaders(headersOptions);
    const options = {
      params: new HttpParams(),
      reportProgress: true,
      headers
    };
    const request = new HttpRequest('POST', url, paramsData, options);
    return this.httpClient.request(request);
  }

  // CapacitorHttp.post() no soporta eventos de progreso (a diferencia del HttpClient de Angular),
  // así que en nativo solo emitimos el evento final (HttpEventType.Response), envuelto en las
  // mismas clases HttpResponse/HttpErrorResponse de Angular para que el resto del flujo (uploadFile
  // en file.component.ts, onEventUploadResponse en bid-status/offer-status) no necesite cambios.
  private uploadNative(url: string, paramsData?: {}, token?: string): Observable<HttpEvent<any>> {
    const headers: { [key: string]: string } = { 'Content-Type': 'application/json' };
    if (token) {
      headers.Authorization = 'Bearer ' + token;
    }
    return from(
      CapacitorHttp.post({ url, headers, data: paramsData }).then(resp => {
        if (resp.status >= 200 && resp.status < 300) {
          return new HttpResponse({ status: resp.status, body: resp.data, url: resp.url });
        }
        throw new HttpErrorResponse({ status: resp.status, error: resp.data, url: resp.url });
      })
    );
  }


  public toBase64(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = this.getFileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // Zone.js parchea FileReader globalmente; en nativo (Capacitor WKWebView/Android WebView) la
  // instancia parcheada puede no disparar onload nunca, dejando la Promise colgada para siempre.
  // Mismo workaround ya aplicado en money-out-change-account.component.ts y file-card.component.ts.
  private getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)['__zone_symbol__originalInstance'];
    return zoneOriginalInstance || fileReader;
  }

}
